import { render, staticRenderFns } from "./AdminFRMatrix.vue?vue&type=template&id=62bc253b&"
import script from "./AdminFRMatrix.vue?vue&type=script&lang=js&"
export * from "./AdminFRMatrix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports